import React from 'react';

import {
  Box, Grid, LinearProgress, Typography
} from '@mui/material';

import PanelCustomPage from 'Shared/Components/PanelCustom/index';
import HomeUserBanner from '../HomeBanner/index';
import { IHomeResultPanel } from 'Module/Home/Interface';
import { IHomeTargetsSupplierPage } from 'Module/HomeUser/Interface/HomeTargetsSupplier';
import HomeListPage from '../HomeUserLists/index';
import Tabs from '../HomeUserTabs/index';


function HomeAssociatePage(props: IHomeTargetsSupplierPage) {
  const [resultPanelAssociates, setResultPanelAssociates] = React.useState<IHomeResultPanel>({ result: [] })
  const toggleResultPanelAssociates = (values: IHomeResultPanel) => {
    setResultPanelAssociates(values)
  }

  React.useEffect(() => {
    if (props.resultPanelAssociates) {
      toggleResultPanelAssociates(props.resultPanelAssociates);
    }

  }, [props.resultPanelAssociates, props.dateUpdateInfo])

  return (
    <Box id="HomeAssociatePage" key="HomeAssociatePage">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <HomeUserBanner />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography component={'div'} align='center'>
            <HomeListPage {...props} />
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container spacing={2}>
            {props.showLoadingGoalMix ?
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography component={'div'} align='center'>
                  <LinearProgress />
                </Typography>
              </Grid>
              :
              <React.Fragment>
                {resultPanelAssociates && resultPanelAssociates.result.length > 0 &&
                  resultPanelAssociates.result.map((el, index) => {
                    return (
                      <Grid item key={index} xs={12} sm={6} md={6} lg={6} xl={6}>
                        <Box className='PanelCustomPageBox'>
                          <PanelCustomPage
                            key={index}
                            title={el ? el.title : ''}
                            value={el ? el.value : ''}
                            type={el ? el.type : ''}
                            alert={el ? el.alert : ''}
                            anotation={el ? el.anotation : ''}
                          />
                        </Box>
                      </Grid>
                    )
                  })
                }
              </React.Fragment>
            }
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Tabs {...props} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default HomeAssociatePage;
